import "./errorPage.scss";

export const ErrorPage = () => {
  return (
    <div className="error-page flex column-direction w-100">
      404 page
    </div>
  );
};
